module.exports = __webpack_public_path__ + "static/img/rm_brand_back_aimeikongjian_details.bda9e31.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/rm_brand_back_aimeikongjian_details.png
// module id = j6gI
// module chunks = 1